module.exports = __webpack_public_path__ + "img/imgCertificado.126e5bba.png";